(() => {
  const mountCurrency = () => {
    const widget = document.querySelector('.wp-currency--mobile');
    if (!widget) return false;
    if (widget.parentElement !== document.body) document.body.append(widget);
    widget.classList.add('cb-floating-currency');
    return true;
  };
  if (!mountCurrency()) {
    const observer = new MutationObserver(() => {
      if (mountCurrency()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', mountCurrency);
})();
